export const CommitsRoutePath = '/:owner/:repo/pull/:pr_number/commits'
export const ChangesRoutePath = '/:owner/:repo/pull/:pr_number/changes'
export const ChangesWithRangeRoutePath = '/:owner/:repo/pull/:pr_number/changes/:range'
export const ChecksRoutePath = '/:owner/:repo/pull/:pr_number/checks'
export const ArtifactsRoutePath = '/:owner/:repo/pull/:pr_number/artifacts'

// deprecated but still supported for backward compatibility (ie - react partials on Rails Files Changed)
export const FilesRoutePath = '/:owner/:repo/pull/:pr_number/files'

// These routes are not currently part of the app but should be supported by the route manager and layout for future use
export const FindingsRoutePath = '/:owner/:repo/pull/:pr_number/findings'
export const WalkthroughRoutePath = '/:owner/:repo/pull/:pr_number/walkthrough'
